module.exports = __webpack_public_path__ + "static/img/02.9e0ca37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/commodity/04/02.jpg
// module id = O0HL
// module chunks = 0